import { createServerFn } from "@tanstack/react-start";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";
import { supabaseAdmin } from "@/integrations/supabase/client.server";

/**
 * Returnerar premium-status för inloggad användare.
 * Använder admin-klienten för att förbi RLS – eliminerar race-conditions
 * och RLS-edge-cases (t.ex. JWT-claim-hydration vid första laddning) som
 * gjorde att vissa kunder fastnade i "locked" trots aktivt köp.
 */
export const getMyPremiumStatus = createServerFn({ method: "GET" })
  .middleware([requireSupabaseAuth])
  .handler(async ({ context }) => {
    const { supabase, userId } = context;
    const { data: userData } = await supabase.auth.getUser();
    const email = userData.user?.email?.toLowerCase() ?? null;

    // Rotorsak-fix: gästköp med samma e-post kopplas till kontot direkt vid
    // första statuskontrollen. Utan detta ligger köpet kvar okopplat och
    // kunden möts av betalvägg efter inloggning.
    if (email) {
      await supabaseAdmin
        .from("premium_access")
        .update({ user_id: userId })
        .is("user_id", null)
        .eq("email", email.toLowerCase());
    }


    // Matcha på user_id ELLER e-post. Detta gör att en inloggad kund som
    // (av misstag) betalade med en annan adress i Stripe ändå får premium
    // så snart raden kopplats till kontot – antingen via checkout-metadata
    // eller via "Hämta mitt köp"-flödet på dashboard.
    let query = supabaseAdmin
      .from("premium_access")
      .select("active_until")
      .gte("active_until", new Date().toISOString())
      .order("active_until", { ascending: false })
      .limit(1);

    if (email) {
      query = query.or(`user_id.eq.${userId},email.eq.${email}`);
    } else {
      query = query.eq("user_id", userId);
    }

    const { data } = await query.maybeSingle();
    return { activeUntil: (data?.active_until as string | null) ?? null };
  });

